import { motion } from "framer-motion";
import powerQuoteBg from "@/assets/power-quote-blue-bg.png";
import ApplyCta from "./ApplyCta";

const PowerQuote = () => {
  return (
    <section
      className="py-24 md:py-32 relative overflow-hidden"
      style={{ background: "linear-gradient(180deg, hsl(215 48% 20%), hsl(217 61% 10%))" }}
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img src={powerQuoteBg} alt="" className="w-full h-full object-cover opacity-30" />
      </div>
      {/* Overlay for text readability */}
      <div className="absolute inset-0 bg-gradient-to-r from-[hsl(217_61%_10%/0.7)] via-[hsl(215_48%_20%/0.5)] to-[hsl(217_61%_10%/0.7)]" />

      <div className="container px-4 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="max-w-4xl mx-auto text-center"
        >
          <p className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight">
            "Si tu marca no toma su lugar,{" "}
            <span className="text-[hsl(216_32%_52%/0.8)]">alguien más lo va a hacer.</span>{" "}
            Activá tu reputación."
          </p>

          <div className="mt-8 flex items-center justify-center gap-3">
            <div className="h-px w-12 bg-[hsl(216_38%_33%/0.5)]" />
            <span className="text-sm font-semibold tracking-widest uppercase text-[hsl(216_32%_52%/0.8)]">
              CORESSEN
            </span>
            <div className="h-px w-12 bg-[hsl(216_38%_33%/0.5)]" />
          </div>

          <ApplyCta variant="dark" />
        </motion.div>
      </div>
    </section>
  );
};

export default PowerQuote;
